import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
export default {
  name: "APIKeyList",
  props: ["apiKeys", "showEdit", "isPoiAdministration", "module"],
  components: { InfoDialog },
  data: () => ({
    headers: [
      { text: "Standard", value: "standard", sortable: false },
      { text: "Vorschau", value: "preview", sortable: false },
      { text: "API-Schlüssel", value: "apiKey" },
      { text: "API-Beschreibung", value: "description" },
      { text: "Aktionen", value: "actions", sortable: false, align: "center" }
    ],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    filter: {
      s: ""
    }
  }),
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isPromptAdmin() {
      return this.currentUser?.scopes?.includes("role:prompt_admin");
    },
    currentPrincipalModulePreviewApiKey: {
      get() {
        return this.$store.state.selectedPrincipal.modulePreviewApiKeys[
          this.module
        ];
      },
      // empty setter to avoid warning in console due to computed property without setter
      // eslint-disable-next-line no-unused-vars
      set(value) {}
    },
    cApiKeys() {
      if (this.filter.s?.length > 3) {
        return this.apiKeys.filter(key =>
          key.description.toLowerCase().includes(this.filter.s.toLowerCase())
        );
      }
      return this.apiKeys;
    }
  },
  methods: {
    async nextPage() {
      const pages = Math.ceil(this.cApiKeys.length / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    async previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    async setModulePreviewApiKey(apiKey) {
      if (!this.isAdmin || !this.module) return;
      if (
        this.$store.state.selectedPrincipal.modulePreviewApiKeys[
          this.module
        ] === apiKey.apiKey
      ) {
        this.$store.state.selectedPrincipal.modulePreviewApiKeys[this.module] =
          "";
      } else {
        this.$store.state.selectedPrincipal.modulePreviewApiKeys[this.module] =
          apiKey.apiKey;
      }

      await this.updatePrincipal();
    },
    async updatePrincipal() {
      try {
        if (!this.isAdmin || !this.module) return;
        const headers = getTokenHeader();
        await axios.put(
          `${env.auth_api_client_url}principals/update/${this.$store.state.selectedPrincipal.id}`,
          this.$store.state.selectedPrincipal,
          { headers }
        );
        await this.$store.dispatch("getPrincipals");
      } catch (e) {
        console.error(e);
      }
    },
    addChangedDescription(item) {
      if (!this.isApiKeyEditable(item)) {
        return;
      }
      const index = this.getApiKeyIndex(item);
      this.$emit("addChangedDescription", index);
    },
    getApiKeyIndex(apiKey) {
      return this.apiKeys.findIndex(key => key._id === apiKey._id);
    },
    isApiKeyViewable(apiKey) {
      if (this.isAdmin || this.isPromptAdmin) {
        return true;
      }
      if (!apiKey.userPermission?.length) {
        return false;
      }
      return apiKey.userPermission === "view";
    },
    isApiKeyEditable(apiKey) {
      if (this.isAdmin || this.isPromptAdmin) {
        return true;
      }
      if (!apiKey.userPermission?.length) {
        return false;
      }
      return apiKey.userPermission === "edit";
    }
  }
};
